import { Language } from './base';

const pdash = () => import('../translations/pdash/cy-GB.json');
const webActivities = () => import('../translations/web-activities/cy-GB.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/cy-GB.json');

export default new Language({
    code: 'cy-GB',
    locale: 'cy',
    localName: 'Welsh',
    englishName: 'Welsh',
    territory: 'GB',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
